import { render, staticRenderFns } from "./GP2BrowserQtlDrawer.vue?vue&type=template&id=36241fbb&scoped=true&"
import script from "./GP2BrowserQtlDrawer.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserQtlDrawer.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserQtlDrawer.vue?vue&type=style&index=0&id=36241fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36241fbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36241fbb')) {
      api.createRecord('36241fbb', component.options)
    } else {
      api.reload('36241fbb', component.options)
    }
    module.hot.accept("./GP2BrowserQtlDrawer.vue?vue&type=template&id=36241fbb&scoped=true&", function () {
      api.rerender('36241fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserQtlDrawer.vue"
export default component.exports